import config from "../components/common/Config";
import { getCompanySettings } from "./companySettingsCache";

export function isQuickBooksConnectivityOn(value) {
  return String(value ?? "").toLowerCase() === "yes";
}

export function isQuickBooksTenant(settings) {
  const flag =
    settings?.QuickBooksConnectivity ??
    localStorage.getItem("QuickBooksConnectivity");
  return isQuickBooksConnectivityOn(flag);
}

export async function resolveQuickBooksEnabled() {
  const settings = await getCompanySettings();
  return isQuickBooksTenant(settings);
}

function getAuthToken() {
  return localStorage.getItem("token") || localStorage.getItem("accessToken");
}

export async function pushQuickBooksMaster(path) {
  const token = getAuthToken();
  const tenant = config.PREFIX || localStorage.getItem("accessToken") || "atr";
  const form = new URLSearchParams();
  form.set("tenant", tenant);
  form.set("only_unlinked", "1");
  form.set("limit", "50");
  const url = `${config.API_URL}/api/quickbooks/push/${path}?tenant=${encodeURIComponent(tenant)}`;
  const res = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: form.toString(),
  });
  let data = null;
  try {
    data = await res.json();
  } catch (e) {
    data = { message: await res.text() };
  }
  if (!res.ok) {
    const msg =
      (data && (data.message || data.error || data.msg)) ||
      `HTTP ${res.status}`;
    throw new Error(msg);
  }
  return data;
}

export default isQuickBooksTenant;
